import { useDroppable } from '@dnd-kit/core'
import React, { FC, ReactElement, ReactNode } from 'react'
import { ReportDragDropClasses, ReportDragDropIDs } from './Constants'

type Props = {
    getReportListItems: () => ReactNode
    highlightRows: boolean
    hasHighlight: boolean
    handleKeyDownRoot: (event: React.KeyboardEvent<HTMLDivElement>) => void
    dndDisabled?: boolean
}

export const ReportListWrapper: FC<Props> = ({
    getReportListItems,
    highlightRows,
    hasHighlight,
    handleKeyDownRoot,
    dndDisabled = false
}: Props): ReactElement => {
    const { isOver: isOverRoot, setNodeRef: droppableRoot } = useDroppable({
        id: ReportDragDropIDs.DROPPABLE_ROOT,
        disabled: dndDisabled
    })

    return (
        <div
            onKeyDown={(event): void => handleKeyDownRoot(event)}
            ref={droppableRoot}
            className={`report-list-container report-list-container-root ${highlightRows ? 'highlight-rows' : ''} ${
                hasHighlight ? 'has-highlight' : ''
            } ${isOverRoot ? `${ReportDragDropClasses.DND_CONTENT} ${ReportDragDropClasses.DND_ROOT_WRAPPER}` : ''}`}
        >
            {getReportListItems()}
        </div>
    )
}
